import { Link } from 'react-router-dom'

import ReilmLogo from '../../components/ReilmLogo'

// Review #2, M3.1 / M3.2 / M3.5.1: every auth page had its own copy of this bar, so they
// drifted — signup had no bottom stroke and no canvas max-width, and the other three
// carried a "Start 7-Day Free Trial" CTA Микола asked to drop. One component instead, so
// the next change lands everywhere at once.
// Review #3, D1.4: the logo sat at 1154px on a 2560 viewport — 45% of the width, just left of
// centre. The row was capped at the 1200 canvas AND centred AND given a 120px inset, so the gutter
// was counted twice and grew with the screen. The gutter is now fixed to the viewport, which keeps
// the logo where it is at the design width and stops it drifting on a large monitor.
// M2.1: 72px at rest, taken from Микола's own sentence — the Figma frames disagree on this one and
// he said so himself, so the number comes from his text, not from a frame.
const AuthHeader = () => (
  <header className="h-[72px] bg-brand-pageFill border-b border-brand-muted">
    <div className="h-full px-6 md:px-[120px] flex items-center">
      <Link to="/" className="group flex items-center" aria-label="Arvance home">
        <ReilmLogo className="w-[131px] h-[28px] md:w-[168px] md:h-[36px]" />
      </Link>
    </div>
  </header>
)

export default AuthHeader
